import type { ResourcesConfig } from 'aws-amplify';
import { config } from './env';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.aws.cognito.userPoolId,
      userPoolClientId: config.aws.cognito.userPoolClientId,
      identityPoolId: config.aws.cognito.identityPoolId,
    },
  },
};
